module.exports = require("serialize-error");


//////////////////
// WEBPACK FOOTER
// external "serialize-error"
// module id = 122
// module chunks = 0